import styled from 'styled-components'

export default styled.a`
  color: white;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }`